import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    StyledSnackBar: {
        width: "auto",
        '& .MuiAlert-standardError': {
            width: "100%"
        }
    }
}));